import { COLORS } from "../../utils/js/constants";

export default function ProductRegisterStyle(theme) {
  return {
    root: {
      flexGrow: 1,
      backgroundColor: COLORS.grey,
      padding: "20px",
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    title: {
      color: 'white',
      fontWeight: 'bold',
      marginBottom: '25px'
    },
    image: {
      width: '100%',
      height: '200px',
      objectFit: 'cover'
    },
    uploadButton: {
      backgroundColor: COLORS.lightYellow,
      fontWeight: "bold",
    },
    submitButton: {
      backgroundColor: COLORS.green,
      color: "white",
      fontWeight: "bold",
      marginLeft: 'auto',
      marginTop: '50px',
      display: 'block',
      width: 197
    },
    alignContentFlexStart: {
      alignContent: "flex-start"
    },
  }
}
